import React from "react";

const BookOpenIcon = ({ width = 24, height = 24, fill = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill={fill}
    {...props}
  >
    <path d="M21 4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 14H7a1 1 0 0 1 0-2h13v2zm0-4H7V6h13v8z" />
    <path d="M9 8h8v1H9zm0 2.5h8v1H9zm0 2.5h5v1H9z" />
  </svg>
);

export default BookOpenIcon;
